export default "__VITE_ASSET__ce4b0ee5__"